/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Layout_ProseInputs */



/**
* | output |
* | --- |
* | "Prose (grouped by silence)" |
*
* @param {Transcript_Export_Layout_ProseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_layout_prose = /** @type {((inputs?: Transcript_Export_Layout_ProseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Layout_ProseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
	return /** @type {LocalizedString} */ ("Prose (grouped by silence)")
});